import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";

import { useTypedSelector } from "../../../../../../store/reducers/use-typed-selector";
import TabHeader from "../../../../../general-ui/tab-header/tab-header";
import { PATHNAMES } from "../../../../admin";
import { capitalize } from "../../../../../../utils/utils";
import ActiveEventHeader from '../../../homepage/navigation/panel/headers/active-event-header';
import SessionLayout from "../../../homepage/navigation/panel/session-layout";
import SessionSettings from "../../../homepage/navigation/panel/session-settings";

enum SessionTabNames {
	Layout = 'Layout',
	Settings = 'Settings'
}

const SessionPanel: React.FC = () => {
	const {
		CreateEventReducer: {
			workingEvent
		},
		CreateSessionReducer: {
			workingSession
		}
	} = useTypedSelector(state => state);

	const { id, session, language, tab }: { id: string, session: string, language: string; tab: string; } = useParams();

	const [activeTab, setActiveTab] = useState(tab ? capitalize(tab) : SessionTabNames.Layout);

	const history = useHistory();

	useEffect(() => {
		history.replace(PATHNAMES.Session.SessionLink(id, session, language, activeTab.toLowerCase()));
	}, [history, id, session, language, activeTab]);

	const renderPanel = () => {
		switch (activeTab) {
			case SessionTabNames.Settings:
				return <SessionSettings />;
			default: return <SessionLayout />;
		}
	};
	const title = workingSession?.title?.changed === 'true'
		? workingSession?.title?.base
		: (workingSession?.title?.[language] || 'session');

	return (
		<div className="session-panel-container">
			{workingEvent && workingSession ? (
				<ActiveEventHeader title={title as string}>
					<TabHeader
						tabs={[SessionTabNames.Layout, SessionTabNames.Settings]}
						currentTab={activeTab}
						onClick={(tab: SessionTabNames) => setActiveTab(tab)}
					/>
				</ActiveEventHeader>
			) : null}
			<div className="session-panel-content">
				{renderPanel()}
			</div>
		</div>
	);
};

export default SessionPanel;
